import React, { useState, useEffect } from 'react';
import styles from './Css/HeroSection.module.css';
import { useHeroSectionsByTypePublic } from '../../../hooks/herosection/useHeroSectionPublicHooks';

function OverlayReading() {
  const { heroSections, isLoading: isLoadingHeroSections } = useHeroSectionsByTypePublic("Home");
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(true);

  useEffect(() => {
    if (!heroSections || heroSections.length === 0) return;
    
    let interval;
    if (isPlaying) {
      interval = setInterval(() => {
        setCurrentIndex((prevIndex) => 
          prevIndex === heroSections.length - 1 ? 0 : prevIndex + 1
        );
      }, 8000); // Autoplay every 8 seconds
    }
    
    return () => clearInterval(interval);
  }, [heroSections, isPlaying]);

  if (isLoadingHeroSections || !heroSections || heroSections.length === 0) {
    return <div className={styles.heroLoading}>Loading...</div>;
  }

  const currentHero = heroSections[currentIndex];

  const handlePlayPause = () => {
    setIsPlaying(!isPlaying);
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === heroSections.length - 1 ? 0 : prevIndex + 1
    );
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? heroSections.length - 1 : prevIndex - 1
    );
  };

  return (
    <div className={styles.heroContainer}>
      <div className={styles.heroBackground}>
        <picture>
          <source media="(min-width: 768px)" srcSet={currentHero.computer_image} />
          <source media="(max-width: 767px)" srcSet={currentHero.mobile_image} />
          <img 
            src={currentHero.computer_image} 
            alt={currentHero.title} 
            className={styles.heroImage} 
          />
        </picture>
        <div className={styles.heroGradientOverlay}></div>
      </div>
      
      <div className={styles.heroContent}>
        <h1 className={styles.heroTitle}>{currentHero.title}</h1>
        <p className={styles.heroDescription}>{currentHero.description}</p>
        
        <div className={styles.heroButtons}>
          <button className={styles.btnPlay}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 4l15 8-15 8V4z" fill="currentColor" />
            </svg>
            Read
          </button>
         
        </div>
      </div>
    
      
     
    </div>
  );
}

export default OverlayReading;